import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, withRouter } from "react-router-dom";
import Card from "../../shared/component/Card/Card";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import { toast } from "react-toastify";
import "./CollegeDetail.scss";
import { classHelper } from "../../shared/utils/stringUtils";
import Image from "../../shared/component/UI/Image";
import {
	AsiaRankIcon,
	CaretDown,
	ChalkboardTeacherIcon,
	ChromeIcon,
	DownloadBrochureFillIcon,
	DownloadBrochureIcon,
	EnvelopeIcon,
	FacebookIcon,
	GlobalRankIcon,
	HeartIconFilled,
	HeartIconOutline,
	InstagramIcon,
	MarkerIcon,
	PhoneIcon,
	PlayCircleIcon,
	SearchIcon,
	StarIcon,
	StudentIconOutline,
	TopRightArrowIcon,
	TwitterIcon,
	WhatsappIcon,
	YoutubeIcon,
} from "../../shared/component/svg/Icons";
import DefaultProfilePicture from "../../assets/image/profiledefaultImage.png";
import Anchor from "../../shared/component/UI/Anchor";
import MediaViewer from "../../shared/component/MediaViewer/MediaViewer";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Accordion, OverlayTrigger, Tooltip } from "react-bootstrap";
import CarouselIndicator from "../../shared/component/CarouselIndicator/CarouselIndicator";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import { formatString } from "../../shared/utils/string";
import { numberToRomanNumeral } from "../../shared/utils/numberUtils";
import { groupBy } from "lodash";
import { Helmet } from "react-helmet";

const COLLEGE_TYPE_MAPPING = {
	government: Variable.STATE_UNIVERSITY,
	private: Variable.PRIVATE_UNIVERSITY,
};
const EMBED_REGEX = /![23]d(-?[\d.]+)/g;

const YouTubeGetID = (url) => {
	var ID = "";
	url = url.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
	if (url[2] !== undefined) {
		ID = url[2].split(/[^0-9a-z_-]/i);
		ID = ID[0];
	} else {
		ID = url;
	}
	return ID;
};

const CollegeDetail = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, ...props }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [collegeData, setCollegeData] = useState(null);
	const [mediaRoll, setMediaRoll] = useState([]);
	const [thumbRoll, setThumbRoll] = useState([]);
	const [facultiesData, setFacultiesData] = useState([]);
	const [showMediaModal, setShowMediaModal] = useState({
		show: false,
		idx: -1,
	});
	const [majorSearch, setMajorSearch] = useState("");
	const [showMoreMajor, setShowMoreMajor] = useState(false);
	const [testimonyIdx, setTestimonyIdx] = useState(0);
	const [mapIdx, setMapIdx] = useState(0);
	let location = useLocation();

	// Get the id of a college
	// If they don't have any college, redirect to the home page
	useEffect(() => {
		if (location?.pathname?.includes(RoutePath.COLLEGE_DETAIL)) {
			let url = location?.pathname;
			let id = url?.substring(url.lastIndexOf("/") + 1);
			if (id !== RoutePath.COLLEGE_DETAIL && !isNaN(id)) {
				getCollegeDetails(id);
			} else {
				toast.error(Variable.COLLEGE_NOT_FOUND[ENV_NAME]);
				props.history.push(RoutePath.ROOT);
			}
		}
	}, [location]); // eslint-disable-line

	// Get college details
	// If API error, redirect to the home page
	const getCollegeDetails = async (id) => {
		setIsLoading(true);
		let res = await makeRequest(generateRequestOptions("collegeDetail", { urlParams: id + "/" }));
		if (res.code === 200) {
			setCollegeData(res.data);

			// Image preprocess
			let videoFirst = res.data?.college_media_detail
				?.map((i, idx) => ({ ...i, idx }))
				?.sort((a, b) => {
					let aHasVid = a?.video || a?.video_external_url;
					let bHasVid = b?.video || b?.video_external_url;
					if (aHasVid && !bHasVid) return -1;
					if (!aHasVid && bHasVid) return 1;
					return a?.idx - b?.idx;
				});
			let medias = [
				{
					url: res.data?.banner_image,
					type: "image",
				},
			];
			let thumbs = [res.data?.banner_image];
			medias = medias.concat(
				videoFirst?.flatMap((i) => {
					if (i?.image || i?.image_external_url) {
						return {
							url: i?.image || i?.image_external_url,
							type: "image",
						};
					}
					if (i?.video || i?.video_external_url) {
						return {
							url: i?.video || i?.video_external_url,
							type: "video",
						};
					}
					return [];
				})
			);
			thumbs = thumbs.concat(
				videoFirst?.flatMap((i) =>
					i?.image || i?.image_external_url
						? i?.image || i?.image_external_url
						: i?.video_external_url
						? `http://img.youtube.com/vi/${YouTubeGetID(i?.video_external_url)}/mqdefault.jpg`
						: i?.video
						? ""
						: []
				)
			);
			setMediaRoll(medias);
			setThumbRoll(thumbs);

			// Faculty/Major preprocess
			setFacultiesData(groupBy(res.data?.majors_detail, "faculty_category"));
		} else {
			toast.error(Variable.COLLEGE_NOT_FOUND[ENV_NAME]);
			// props.history.push(RoutePath.ROOT);
		}
		setIsLoading(false);
	};

	const getShareLink = (embedLink) => {
		if (!embedLink) return "";
		var match = embedLink.match(EMBED_REGEX);
		return `https://www.google.com/maps/@${match?.[1]?.replace(/![23]d/, "")},${match?.[0]?.replace(
			/![23]d/,
			""
		)},16z`;
	};

	return (
		<div className="container college-detail">
			{collegeData?.name && (
				<Helmet>
					<title>Direktori Kampus Terbaik di Indonesia - Portal Sekolah - {collegeData?.name || "-"}</title>
				</Helmet>
			)}
			{isLoading ? (
				<Card className="header-loading" isLoading />
			) : (
				<div className="header-card">
					<Image
						src={collegeData?.banner_image}
						className="img-header cursorPointer"
						onClick={() => setShowMediaModal({ show: true, idx: 0 })}
					/>
					<div className="header-body">
						{collegeData?.ranking && (
							<OverlayTrigger
								placement="auto"
								overlay={
									<Tooltip id="ranking-tooltip" className="custom-tooltip">
										{collegeData && !collegeData.abroad_accreditation ? 
											<span>{Variable.BASED_ON_WEBOMETRIC_INDO[ENV_NAME]}</span> 
											: 
											<span>{Variable.BASED_ON_WEBOMETRIC_WORLD[ENV_NAME]}</span> }
									</Tooltip>
								}
							>
								<div className="college-rank">
									<div>{Variable.RANKING[ENV_NAME]}</div>
									<div className="college-rank-num">{collegeData?.ranking || "-"}</div>
								</div>
							</OverlayTrigger>
						)}
						<div className="college-type">
							{COLLEGE_TYPE_MAPPING?.[collegeData?.college_type?.toLowerCase()]?.[ENV_NAME] ||
								collegeData?.college_type ||
								"-"}
						</div>
						<div className="d-flex">
							<div className="p-xxs me-sm">
								<Image className="college-logo" src={collegeData?.college_logo} />
							</div>
							<div className="flex-grow-1">
								<div className="college-name mb-xxs">{collegeData?.name || "-"}</div>
								<div className="college-location">
									{`${collegeData?.college_location_detail?.[0]?.city || "-"}, ${
										collegeData?.college_location_detail?.[0]?.province || "-"
									}`}
								</div>
							</div>
						</div>
						<div className="divider" />
						<div className="d-flex-desktop align-items-center justify-content-between">
							<div className="flex-all-center socmed-icons">
								{collegeData?.instagram_account_url && (
									<Anchor href={collegeData?.instagram_account_url} target="_blank">
										<InstagramIcon fill="#BEC4CF" />
									</Anchor>
								)}
								{collegeData?.facebook_account_url && (
									<Anchor href={collegeData?.facebook_account_url} target="_blank">
										<FacebookIcon fill="#BEC4CF" />
									</Anchor>
								)}
								{collegeData?.twitter_account_url && (
									<Anchor href={collegeData?.twitter_account_url} target="_blank">
										<TwitterIcon fill="#BEC4CF" />
									</Anchor>
								)}
								{collegeData?.youtube_account_url && (
									<Anchor href={collegeData?.youtube_account_url} target="_blank">
										<YoutubeIcon fill="#BEC4CF" />
									</Anchor>
								)}
							</div>
							<button
								className="btn fav-button my-sm"
								onClick={() => {
									if (fetchingAddRemoveFavorites) return;
									if (isAuthenticated) {
										// call API
										props.addRemoveFavorite(
											collegeData?.is_fav ? "remove" : "add",
											"major",
											collegeData?.is_fav ? collegeData?.fav_id : collegeData?.id,
											(res) => {
												if (collegeData?.is_fav) {
													setCollegeData((p) => ({
														...p,
														fav_id: null,
														is_fav: false,
													}));
												} else {
													setCollegeData((p) => ({
														...p,
														fav_id: res?.data?.id,
														is_fav: true,
													}));
												}
											}
										);
									} else {
										props.openLoginModal();
									}
								}}
							>
								{collegeData?.is_fav ? (
									<>
										<HeartIconFilled className="me-xs" width="2rem" height="2rem" fill="#F24822" />
										{Variable.REMOVE_FROM_FAVORITES[ENV_NAME]}
									</>
								) : (
									<>
										<HeartIconOutline
											className="me-xs"
											width="2rem"
											height="2rem"
											stroke="#F24822"
										/>
										{Variable.ADD_TO_FAVORITES[ENV_NAME]}
									</>
								)}
							</button>
						</div>
					</div>
				</div>
			)}
			<div className="college-info-cont">
				<CollegeSectionContainer className="college-info" title={Variable.GENERAL_INFORMATION[ENV_NAME]}>
					<div className="college-info-item">
						<StarIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
						<div className="cii-label me-sm">{Variable.ACCREDITATION[ENV_NAME]}</div>
						<div className="cii-item">
							{collegeData?.abroad_accreditation ||
								collegeData?.college_accreditation ||
								Variable.NO_ACCREDITATION[ENV_NAME]}
						</div>
					</div>
					{collegeData?.qs_asia_ranking && (
						<div className="college-info-item">
							<AsiaRankIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
							<div className="cii-label me-sm">{Variable.ASIAN_RANKING[ENV_NAME]}</div>
							<div className="cii-item">{collegeData?.qs_asia_ranking || "-"}</div>
						</div>
					)}
					{collegeData?.qs_world_ranking && (
						<div className="college-info-item mb-0">
							<GlobalRankIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
							<div className="cii-label me-sm">{Variable.WORLD_RANKING[ENV_NAME]}</div>
							<div className="cii-item">{collegeData?.qs_world_ranking || "-"}</div>
						</div>
					)}
					<div className="divider" />
					<div className="college-info-item">
						<StudentIconOutline className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
						<div className="cii-label me-sm">{Variable.STUDENT[ENV_NAME]}</div>
						<div className="cii-item">
							{collegeData?.number_of_students || Variable.DATA_NOT_AVAILABLE[ENV_NAME]}
						</div>
					</div>
					<div className="college-info-item mb-0">
						<ChalkboardTeacherIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
						<div className="cii-label me-sm">{Variable.LECTURER[ENV_NAME]}</div>
						<div className="cii-item">
							{collegeData?.number_of_lecturers || Variable.DATA_NOT_AVAILABLE[ENV_NAME]}
						</div>
					</div>
					<div className="divider" />
					<div className="college-info-item">
						<ChromeIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
						<div className={`cii-label me-sm ${ENV_NAME === "bhs" ? "font-italic" : ""}`}>
							{Variable.WEBSITE[ENV_NAME]}
						</div>
						<div className="cii-item">
							{collegeData?.website ? (
								<Anchor href={collegeData?.website || "-"} target="_blank">
									{collegeData?.website || "-"}
								</Anchor>
							) : (
								"-"
							)}
						</div>
					</div>
					<div className="college-info-item">
						<EnvelopeIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
						<div className={`cii-label me-sm ${ENV_NAME === "bhs" ? "font-italic" : ""}`}>
							{Variable.EMAIL[ENV_NAME]}
						</div>
						<div className="cii-item">
							{collegeData?.primary_email ? (
								<Anchor href={"mailto:" + collegeData?.primary_email || "-"} target="_blank">
									{collegeData?.primary_email || "-"}
								</Anchor>
							) : (
								"-"
							)}
						</div>
					</div>
					<div className="college-info-item">
						<PhoneIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
						<div className="cii-label me-sm">{Variable.PHONE[ENV_NAME]}</div>
						<div className="cii-item">{collegeData?.primary_phone || "-"}</div>
					</div>
					<div className="college-info-item mb-0">
						<WhatsappIcon className="mw-2p4rem me-sm" width="2.4rem" height="2.4rem" stroke="#193560" />
						<div className="cii-label me-sm">{Variable.WHATSAPP[ENV_NAME]}</div>
						<div className="cii-item">
							{collegeData?.whatsapp_number ? (
								<Anchor href={"https://wa.me/" + collegeData?.whatsapp_number || "-"} target="_blank">
									{collegeData?.whatsapp_number || "-"}
								</Anchor>
							) : (
								"-"
							)}
						</div>
					</div>
					{collegeData?.brochure && (
						<Anchor href={collegeData?.brochure} target="_blank" className="text-decoration-none" download>
							<button className="mt-std btn btn-cta-secondary btn-sm flex-all-center">
								<div className="btn-icon me-xs">
									<DownloadBrochureIcon
										className="icon-standby"
										width="1.6rem"
										height="1.6rem"
										stroke="#193560"
									/>
									<DownloadBrochureFillIcon
										className="icon-hover"
										width="1.6rem"
										height="1.6rem"
										fill="#193560"
									/>
								</div>
								{Variable.DOWNLOAD_BROCHURE[ENV_NAME]}
							</button>
						</Anchor>
					)}
				</CollegeSectionContainer>
				<CollegeSectionContainer className="media-container">
					{(mediaRoll?.slice(1, 5) || [])?.map((i, idx) => (
						<div
							className="media-container-item"
							key={idx}
							onClick={() => setShowMediaModal({ show: true, idx: idx + 1 })}
						>
							<div className={`overlay-hover ${idx === 3 && mediaRoll?.length > 4 ? "show" : ""}`}>
								{idx === 3 && mediaRoll?.length > 4 ? (
									<h4 className="text-white mb-0">+{mediaRoll?.length - 3}</h4>
								) : i?.type === "video" ? (
									<PlayCircleIcon width="30%" />
								) : (
									<></>
								)}
							</div>
							<Image
								className="media-container-image"
								src={
									i?.type === "video" && i?.url
										? `http://img.youtube.com/vi/${YouTubeGetID(i?.url)}/mqdefault.jpg`
										: i?.url
								}
							/>
						</div>
					))}
				</CollegeSectionContainer>
			</div>
			{collegeData?.college_description && (
				<CollegeSectionContainer title={Variable.COLLEGE_DESCRIPTION[ENV_NAME]}>
					<div
						className="force-styling-wysiwyg"
						dangerouslySetInnerHTML={{ __html: collegeData?.college_description || "" }}
					/>
				</CollegeSectionContainer>
			)}
			{collegeData?.facilities?.length > 0 && (
				<CollegeSectionContainer title={Variable.FACILITIES[ENV_NAME]}>
					<div className="facilities-cont">
						{collegeData?.facilities?.map((i, idx) => (
							<div className="facilities-cont-item" key={idx}>
								{i}
							</div>
						))}
					</div>
				</CollegeSectionContainer>
			)}
			{Object.keys(facultiesData)?.length > 0 && (
				<CollegeSectionContainer
					title={
						<div className="college-desc-cont flex-column">
							<div>
								<h2 className="csc-header flex-grow-1 mb-sm">
									{Variable.FACULTIES_AND_MAJORS[ENV_NAME]}
								</h2>
							</div>
							<div className="d-flex w-100">
								<div className="ms-sm-auto form-group search-bar mb-0">
									<SearchIcon className="searchIcon" />
									<input
										type="text"
										name="searchText"
										value={majorSearch || ""}
										onChange={(e) => setMajorSearch(e.target.value)}
										placeholder={Variable.SRC_MAJOR_PLACEHOLDER[ENV_NAME]}
									/>
								</div>
							</div>
						</div>
					}
				>
					{(!majorSearch && !showMoreMajor && Object.keys(facultiesData)?.length > 4
						? (Object.keys(facultiesData) || [])?.slice(0, 4)
						: Object.keys(facultiesData) || []
					)?.map((i, idx) => {
						let filteredMajor = majorSearch
							? facultiesData?.[i]?.filter((j) =>
									j?.major_name?.toLowerCase()?.includes(majorSearch?.toLowerCase())
							  )
							: facultiesData?.[i];
						if (filteredMajor?.length === 0) {
							return undefined;
						}
						return (
							<div className="faculty-cont" key={idx}>
								<div className="d-flex align-items-center">
									<h4 className={`mb-0 ${i === "null" ? "" : "me-std"}`}>
										<strong>{i === "null" ? "" : i}</strong>
									</h4>
									<div className="major-count">{`${facultiesData?.[i]?.length || 0} ${
										Variable.MAJORS[ENV_NAME]
									}`}</div>
								</div>
								<div className="major-cont">
									{filteredMajor?.map((j) => (
										<Link
											key={j?.id}
											to={RoutePath.MAJOR_DETAIL + "/" + j?.id}
											className="text-decoration-none"
										>
											<button className="btn btn-cta-secondary btn-sm">{j?.major_name}</button>
										</Link>
									))}
								</div>
							</div>
						);
					})}
					{!majorSearch && !showMoreMajor && Object.keys(facultiesData)?.length > 4 ? (
						<button
							className="btn btn-show-more text-label-dark-blue"
							onClick={() => setShowMoreMajor(true)}
						>
							<CaretDown stroke="#193560" className="me-sm" />
							{Variable.VIEW_MORE[ENV_NAME]}
						</button>
					) : (
						<></>
					)}
				</CollegeSectionContainer>
			)}
			{collegeData?.general_tuition_fees && (
				<CollegeSectionContainer title={Variable.GENERAL_TUITION_FEES[ENV_NAME]}>
					<div
						className="general-tuition force-styling-wysiwyg"
						dangerouslySetInnerHTML={{ __html: collegeData?.general_tuition_fees || "" }}
					/>
				</CollegeSectionContainer>
			)}
			{collegeData?.scholarship_information && (
				<CollegeSectionContainer title={Variable.SCHOLARSHIP_INFORMATION[ENV_NAME]}>
					<div
						className="scholarship-info force-styling-wysiwyg"
						dangerouslySetInnerHTML={{
							__html: collegeData?.scholarship_information || "",
						}}
					/>
					{collegeData?.scholarship_detail?.[0]?.id && (
						<div className="flex-all-center mt-std">
							<Link
								to={RoutePath.SCHOLARSHIP_DETAIL + "/" + collegeData?.scholarship_detail?.[0]?.id}
								className="text-decoration-none"
							>
								<button className="btn btn-cta-secondary btn-sm">{Variable.MORE_INFO[ENV_NAME]}</button>
							</Link>
						</div>
					)}
				</CollegeSectionContainer>
			)}
			{collegeData?.college_testimonial_detail?.length > 0 && (
				<CollegeSectionContainer title={Variable.TESTIMONY[ENV_NAME]} titleClassName="text-center">
					<Carousel
						showStatus={false}
						showIndicators={false}
						showThumbs={false}
						showArrows={false}
						selectedItem={testimonyIdx}
						onChange={(index, _) => setTestimonyIdx(index)}
						className="testimony-carousel"
						centerSlidePercentage={window.screen.width < 960 ? (window.screen.width < 450 ? 100 : 50) : 33}
						centerMode
						emulateTouch
					>
						{collegeData?.college_testimonial_detail?.map((i, idx) => (
							<div className="testimony-card" key={idx}>
								<Image src={i?.profile_picture || DefaultProfilePicture} className="tc-avatar mb-std" />
								<h4 className="text-center">
									<strong>{i?.name}</strong>
								</h4>
								<div className="text-label-dark-gray mb-std">{i?.major_name}</div>
								<div className="text-center">{i?.description}</div>
							</div>
						))}
					</Carousel>
					<CarouselIndicator
						onChangeIndex={setTestimonyIdx}
						idx={testimonyIdx}
						length={collegeData?.college_testimonial_detail?.length}
					/>
				</CollegeSectionContainer>
			)}
			{collegeData?.college_location_detail?.length > 0 && (
				<CollegeSectionContainer
					className="map-card"
					title={
						<div className="map-container">
							<iframe
								key={mapIdx}
								title={"unique" + mapIdx}
								width="100%"
								height="100%"
								frameBorder="0"
								scrolling="no"
								marginHeight="0"
								marginWidth="0"
								src={collegeData?.college_location_detail?.[mapIdx < 0 ? 0 : mapIdx]?.google_map_link}
							/>
						</div>
					}
				>
					<div className="d-flex mb-xs">
						<h3 className="font-weight-semibold mb-0 me-std">{Variable.LOCATION[ENV_NAME]}</h3>
						<div className="location-count">{`${collegeData?.college_location_detail?.length || 0} ${
							Variable.LOCATIONS[ENV_NAME]
						}`}</div>
					</div>
					<Accordion defaultActiveKey={`${mapIdx}`} className="location-accordion">
						{collegeData?.college_location_detail?.map((i, idx) => (
							<Accordion.Item eventKey={`${idx}`} key={idx}>
								<Accordion.Button
									as="div"
									eventKey={`${idx}`}
									className="la-header cursorPointer"
									onClick={() => (mapIdx === idx ? setMapIdx(-1) : setMapIdx(idx))}
								>
									<>
										<h4 className="mb-0">
											<strong>{`${
												formatString(
													Variable.CAMPUS_NUM[ENV_NAME],
													numberToRomanNumeral(idx + 1)
												) || ""
											}`}</strong>
										</h4>
										<div className={`arrow ${mapIdx === idx ? "open" : ""}`}>
											<CaretDown stroke="#193560" className="ms-auto" />
										</div>
									</>
								</Accordion.Button>
								<Accordion.Collapse eventKey={`${idx}`} className="la-content">
									<>
										<div className="d-flex align-items-center mb-sm">
											<MarkerIcon
												width="1.6rem"
												height="1.6rem"
												stroke="#193560"
												className="me-sm mw-std"
											/>
											<div className="flex-grow-1">{`${i?.address}${
												i?.city ? ", " + i?.city : ""
											}${i?.province ? ", " + i?.province : ""}`}</div>
										</div>
										<div className="d-flex flex-column flex-lg-row align-items-stretch position-relative">
											<div className="d-flex">
												<EnvelopeIcon
													width="1.6rem"
													height="1.6rem"
													stroke="#193560"
													className="me-sm mw-std"
												/>
												<div>{i?.email || "-"}</div>
											</div>
											<div className="vertical-divider h-auto show-desktop" />
											<div className="d-flex">
												<TopRightArrowIcon
													width="1.6rem"
													height="1.6rem"
													stroke="#193560"
													className="me-sm mw-std"
												/>
												<Anchor
													href={getShareLink(i?.google_map_link)}
													target="_blank"
													className="text-decoration-none"
												>
													<div className="text-label-dark-gray-2">
														{Variable.OPEN_IN_MAP[ENV_NAME]}
													</div>
												</Anchor>
											</div>
											<div className="vertical-divider h-auto show-desktop" />
											<div className="d-flex">
												<PhoneIcon
													width="1.6rem"
													height="1.6rem"
													stroke="#193560"
													className="me-sm mw-std"
												/>
												<div>{i?.phone || "-"}</div>
											</div>
										</div>
									</>
								</Accordion.Collapse>
							</Accordion.Item>
						))}
					</Accordion>
				</CollegeSectionContainer>
			)}
			<MediaViewer
				ENV_NAME={ENV_NAME}
				show={showMediaModal?.show}
				idx={showMediaModal?.idx}
				medias={mediaRoll}
				thumbs={thumbRoll}
				onHide={() => setShowMediaModal({ show: false, idx: 0 })}
			/>
		</div>
	);
};

const CollegeSectionContainer = ({ ENV_NAME, className, title, titleClassName, children, ...props }) => (
	<section className={classHelper("college-section-cont", className || "")} {...props}>
		{React.isValidElement(title) ? (
			title
		) : title ? (
			<h2 className={classHelper("csc-header", titleClassName || "")}>{title}</h2>
		) : (
			<></>
		)}
		{children}
	</section>
);

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		openLoginModal: () =>
			dispatch({
				type: ActionTypes.OPEN_LOGIN_MODAL,
			}),
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(CollegeDetail));
